const isLocalhost = false;
const isLocalSTS = false;
const isLocalReportsService = false;

const isBetaHost = window.location.hostname.indexOf('-beta') !== -1;
const apiPrefix = isBetaHost ? 'beta' : 'sit'

const baseUrl = isLocalhost
  ? 'http://localhost:62002'
  : `https://api-${apiPrefix}.mworker.com`;

const tokenEndpoint = isLocalSTS
  ? 'https://localhost:44305'
  : 'https://sts-sit.mworker.com';
const reportsServiceEndpoint = isLocalReportsService
  ? 'http://localhost:62004/api/reports'
  : `https://reports-${apiPrefix}.mworker.com/api/reports`;

const exportBatchLayoutId = 346;
const defaultLayoutId = 405;

export const environment = {
  production: false,
  environment: 'sit',
  baseUrl,
  tokenEndpoint: tokenEndpoint + '/connect/token',
  reportsServiceEndpoint,
  clientId: 'MW-Client-Transportation',
  devincoConnectClientId: 'mworker.client',
  enableDevincoConnectLinking: true,
  clientSecret: '6c69c926-5bc9-4c0c-8f69-56d97e78ade2',
  version: require('../../package.json').version,
  syncLocalStorage: ['general'],
  agGridLicenseKey:
    'CompanyName=Devinco AS,LicensedGroup=Ruben Edna,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=5,LicensedProductionInstancesCount=3,AssetReference=AG-020313,ExpiryDate=5_November_2022_[v2]_MTY2NzYwNjQwMDAwMA==8862c7c1bce1fc564b1c79b1b151a4e6',
  applicationInsightKey: '',
  webToWebEnvironmentId: 2,
  endpointMode: 'demo', // Demo mode
  endpoint: 'beta', // Beta mode
  preferenceKey: {
    general: 'mw-transport',
  },
  auditServiceEndpoint: 'https://audit-service-sit.mworker.com',
  auditServiceKey: '8923e2c1-f7a9-4182-ba53-aace771c6ec',
  moduleName: 'mw-transport',
  skipAuthRoutes: [],
  neededUserActions: [],
  firebase: {
    apiKey: 'AIzaSyA2Mlks__Ge7f24dt3kzpHbBvFw_Y-OcGA',
    authDomain: 'flutter-mw.firebaseapp.com',
    databaseURL: 'https://flutter-mw.firebaseio.com',
    projectId: 'flutter-mw',
    storageBucket: 'flutter-mw.appspot.com',
    messagingSenderId: '346238664142',
    appId: '1:346238664142:web:95ec2ccd475062692abf9f',
  },
  skipCompanyProtectionRoutes: [],
  exportBatchLayoutId,
  defaultLayoutId,
};
